class Cliente{
    constructor(id, codigo, nombre, numero_documento, domicilio, localidad, codigo_postal, responsabilidad_iva_id, telefono, lista_id, user_id, dia_visita){
        this.id = id;
        this.codigo = codigo;
        this.nombre = nombre;
        this.numero_documento = numero_documento;
        this.domicilio = domicilio;
        this.localidad = localidad;
        this.codigo_postal = codigo_postal;
        this.responsabilidad_iva_id = responsabilidad_iva_id;
        this.telefono = telefono;
        this.lista_id = lista_id;
        this.user_id = user_id;
        this.dia_visita = dia_visita;
    }
}
export default Cliente;